import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
  es: {
    // Layout
    dashboard: 'Panel',
    channels: 'Canales',
    vod: 'VOD',
    playlists: 'Listas',
    spots: 'Spots',
    avances: 'Avances TV',
    simulcast: 'Simulcast',
    player: 'Player',
    analytics: 'Analíticas',
    settings: 'Ajustes',
    logout: 'Cerrar Sesión',
    
    // Settings
    profile: 'Perfil',
    security: 'Seguridad',
    ssl: 'SSL/HTTPS',
    notifications: 'Notificaciones',
    language: 'Idioma',
    fullName: 'Nombre Completo',
    email: 'Correo Electrónico',
    currentPassword: 'Contraseña Actual',
    newPassword: 'Nueva Contraseña',
    confirmPassword: 'Confirmar Nueva Contraseña',
    updateProfile: 'Guardar Cambios',
    updatePassword: 'Actualizar Contraseña',
    savePreferences: 'Guardar Preferencias',
    
    // Dashboard
    welcomeBack: 'Bienvenido de nuevo',
    controlPanel: 'Panel de Control',
    createdChannels: 'Canales',
    liveNow: 'en vivo ahora',
    totalViewers: 'Espectadores',
    bandwidthUsage: 'Uso de Ancho de Banda',
    systemUptime: 'Tiempo de Actividad',
    activeChannels: 'Canales Activos',
    recentActivity: 'Actividad Reciente',
    systemStatus: 'Estado del Sistema',
    noRecentActivity: 'No hay actividad reciente',
    systemLoad: 'Carga del Sistema',
    memoryUsage: 'Uso de Memoria',
    diskUsage: 'Uso de Disco',
    networkStatus: 'Estado de Red',
    
    // Channels
    channels: 'Canales',
    createChannel: 'Crear Canal',
    channelName: 'Nombre del Canal',
    description: 'Descripción',
    channelType: 'Tipo de Canal',
    live: 'En Vivo',
    vod: 'VOD',
    create: 'Crear',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Eliminar',
    copyStreamKey: 'Copiar Clave de Stream',
    streamKey: 'Clave de Stream',
    status: 'Estado',
    offline: 'Desconectado',
    online: 'Conectado',
    viewers: 'Espectadores',
    embedCode: 'Código Embed',
    share: 'Compartir',
    
    // VOD
    videoOnDemand: 'Video Bajo Demanda',
    uploadVideo: 'Subir Video',
    newFolder: 'Nueva Carpeta',
    folderName: 'Nombre de Carpeta',
    createFolder: 'Crear Carpeta',
    move: 'Mover',
    play: 'Reproducir',
    deleteVideo: 'Eliminar Video',
    storageUsed: 'Almacenamiento Usado',
    totalVideos: 'Total de Videos',
    noVideos: 'No hay videos',
    noVideosMessage: 'Sube tu primer video para comenzar',
    uploadFirstVideo: 'Subir Primer Video',
    home: 'Inicio',
    duration: 'Duración',
    fileSize: 'Tamaño de Archivo',
    created: 'Creado',
    selectFolder: 'Seleccionar Carpeta',
    moveVideo: 'Mover Video',
    
    // Playlists
    playlists: 'Listas',
    createPlaylist: 'Crear Lista',
    playlistName: 'Nombre de Lista',
    playlistDescription: 'Descripción de Lista',
    selectChannel: 'Seleccionar Canal',
    editPlaylist: 'Editar Lista',
    deletePlaylist: 'Eliminar Lista',
    active: 'Activa',
    inactive: 'Inactiva',
    schedule: 'Programación',
    items: 'Elementos',
    noPlaylists: 'No hay listas',
    noPlaylistsMessage: 'Crea tu primera lista de reproducción',
    createFirstPlaylist: 'Crear Primera Lista',
    programContent: 'Programa contenido para tus canales',
    
    // Simulcast
    simulcast: 'Simulcast',
    createSimulcast: 'Crear Simulcast',
    selectChannel: 'Seleccionar Canal',
    platform: 'Plataforma',
    streamKey: 'Clave de Stream',
    rtmpUrl: 'URL RTMP',
    enable: 'Habilitar',
    disable: 'Deshabilitar',
    deleteSimulcast: 'Eliminar Simulcast',
    copyStreamKey: 'Copiar Clave',
    streamKeyCopied: 'Clave copiada',
    showStreamKey: 'Mostrar Clave',
    hideStreamKey: 'Ocultar Clave',
    noSimulcasts: 'No hay configuraciones de simulcast',
    noSimulcastsMessage: 'Crea tu primera configuración de simulcast',
    createFirstSimulcast: 'Crear Primera Configuración',
    youtubeLive: 'YouTube Live',
    facebookLive: 'Facebook Live',
    twitchLive: 'Twitch',
    tiktokLive: 'TikTok Live',
    instagramLive: 'Instagram Live',
    
    // Player
    player: 'Reproductor',
    title: 'Reproductor',
    subtitle: 'Previsualiza tus canales y obtén códigos de inserción',
    selectChannelLabel: 'Seleccionar Canal',
    selectHere: 'Selecciona Aquí',
    selectChannel: 'Selecciona un canal',
    noSignal: 'No hay señal de video para mostrar',
    shareChannel: 'Compartir Canal',
    autoplay: 'Autoplay',
    muted: 'Silenciar',
    playerUrl: 'URL DEL PLAYER',
    url: 'URL',
    iframeCode: 'CÓDIGO IFRAME',
    copyIframe: 'Copiar iFrame',
    channelStatus: 'Estado del Canal',
    live: 'En Vivo',
    offline: 'Offline',
    autoResolution: 'Resolución automática',
    channelsError: 'No se pudieron cargar tus canales',
    channelError: 'Canal no encontrado o error de configuración',
    copied: 'copiado',
    copyError: 'Error al copiar',
    embedCode: 'Código de Inserción',
    copyEmbedCode: 'Copiar Código',
    embedCodeCopied: 'Código copiado',
    sharePlayer: 'Compartir Reproductor',
    noChannelSelected: 'Ningún canal seleccionado',
    playerError: 'Error cargando reproductor',
    liveStream: 'Transmisión en Vivo',
    
    // Analytics
    analytics: 'Analíticas',
    overview: 'Resumen',
    totalViews: 'Vistas Totales',
    totalWatchTime: 'Tiempo Total Visualizado',
    averageWatchTime: 'Tiempo Promedio',
    peakViewers: 'Pico de Espectadores',
    activityChart: 'Actividad',
    contentDistribution: 'Distribución de Contenido',
    trends: 'Tendencias',
    last7Days: 'Últimos 7 días',
    last30Days: 'Últimos 30 días',
    last90Days: 'Últimos 90 días',
    exportData: 'Exportar Datos',
    
    // Timezones
    timezones: {
      'UTC': 'UTC',
      'America/Mexico_City': 'Ciudad de México (GMT-6)',
      'America/New_York': 'Nueva York (GMT-5)',
      'America/Los_Angeles': 'Los Ángeles (GMT-8)',
      'America/Chicago': 'Chicago (GMT-6)',
      'America/Denver': 'Denver (GMT-7)',
      'America/Toronto': 'Toronto (GMT-5)',
      'America/Vancouver': 'Vancouver (GMT-8)',
      'America/Sao_Paulo': 'São Paulo (GMT-3)',
      'America/Buenos_Aires': 'Buenos Aires (GMT-3)',
      'America/Lima': 'Lima (GMT-5)',
      'America/Bogota': 'Bogotá (GMT-5)',
      'Europe/Madrid': 'Madrid (GMT+1)',
      'Europe/London': 'Londres (GMT+0)',
      'Europe/Paris': 'París (GMT+1)',
      'Europe/Berlin': 'Berlín (GMT+1)',
      'Europe/Rome': 'Roma (GMT+1)',
      'Europe/Amsterdam': 'Ámsterdam (GMT+1)',
      'Europe/Stockholm': 'Estocolmo (GMT+1)',
      'Asia/Tokyo': 'Tokio (GMT+9)',
      'Asia/Shanghai': 'Shanghái (GMT+8)',
      'Asia/Hong_Kong': 'Hong Kong (GMT+8)',
      'Asia/Singapore': 'Singapur (GMT+8)',
      'Asia/Dubai': 'Dubái (GMT+4)',
      'Australia/Sydney': 'Sídney (GMT+10)',
      'Australia/Melbourne': 'Melbourne (GMT+10)',
      'Pacific/Auckland': 'Auckland (GMT+12)',
      'Pacific/Honolulu': 'Honolulu (GMT-10)',
      'Africa/Cairo': 'El Cairo (GMT+2)',
      'Africa/Johannesburg': 'Johannesburgo (GMT+2)'
    }
  },
  en: {
    // Layout
    dashboard: 'Dashboard',
    channels: 'Channels',
    vod: 'VOD',
    playlists: 'Playlists',
    spots: 'Spots',
    avances: 'TV Promos',
    simulcast: 'Simulcast',
    player: 'Player',
    analytics: 'Analytics',
    settings: 'Settings',
    logout: 'Logout',
    
    // Settings
    profile: 'Profile',
    security: 'Security',
    ssl: 'SSL/HTTPS',
    notifications: 'Notifications',
    language: 'Language',
    fullName: 'Full Name',
    email: 'Email',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    updateProfile: 'Save Changes',
    updatePassword: 'Update Password',
    savePreferences: 'Save Preferences',
    
    // Dashboard
    welcomeBack: 'Welcome back',
    controlPanel: 'Control Panel',
    createdChannels: 'Created Channels',
    liveNow: 'live now',
    totalViewers: 'Total Viewers',
    bandwidthUsage: 'Bandwidth Usage',
    systemUptime: 'System Uptime',
    activeChannels: 'Active Channels',
    recentActivity: 'Recent Activity',
    systemStatus: 'System Status',
    noRecentActivity: 'No recent activity',
    systemLoad: 'System Load',
    memoryUsage: 'Memory Usage',
    diskUsage: 'Disk Usage',
    networkStatus: 'Network Status',
    
    // Channels
    channels: 'Channels',
    createChannel: 'Create Channel',
    channelName: 'Channel Name',
    description: 'Description',
    channelType: 'Channel Type',
    live: 'Live',
    vod: 'VOD',
    create: 'Create',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    copyStreamKey: 'Copy Stream Key',
    streamKey: 'Stream Key',
    status: 'Status',
    offline: 'Offline',
    online: 'Online',
    viewers: 'Viewers',
    embedCode: 'Embed Code',
    share: 'Share',
    
    // VOD
    videoOnDemand: 'Video On Demand',
    uploadVideo: 'Upload Video',
    newFolder: 'New Folder',
    folderName: 'Folder Name',
    createFolder: 'Create Folder',
    move: 'Move',
    play: 'Play',
    deleteVideo: 'Delete Video',
    storageUsed: 'Storage Used',
    totalVideos: 'Total Videos',
    noVideos: 'No videos',
    noVideosMessage: 'Upload your first video to get started',
    uploadFirstVideo: 'Upload First Video',
    home: 'Home',
    duration: 'Duration',
    fileSize: 'File Size',
    created: 'Created',
    selectFolder: 'Select Folder',
    moveVideo: 'Move Video',
    
    // Playlists
    playlists: 'Playlists',
    createPlaylist: 'Create Playlist',
    playlistName: 'Playlist Name',
    playlistDescription: 'Playlist Description',
    selectChannel: 'Select Channel',
    editPlaylist: 'Edit Playlist',
    deletePlaylist: 'Delete Playlist',
    active: 'Active',
    inactive: 'Inactive',
    schedule: 'Schedule',
    items: 'Items',
    noPlaylists: 'No playlists',
    noPlaylistsMessage: 'Create your first playlist',
    createFirstPlaylist: 'Create First Playlist',
    programContent: 'Schedule content for your channels',
    
    // Simulcast
    simulcast: 'Simulcast',
    createSimulcast: 'Create Simulcast',
    selectChannel: 'Select Channel',
    platform: 'Platform',
    streamKey: 'Stream Key',
    rtmpUrl: 'RTMP URL',
    enable: 'Enable',
    disable: 'Disable',
    deleteSimulcast: 'Delete Simulcast',
    copyStreamKey: 'Copy Key',
    streamKeyCopied: 'Key copied',
    showStreamKey: 'Show Key',
    hideStreamKey: 'Hide Key',
    noSimulcasts: 'No simulcast configurations',
    noSimulcastsMessage: 'Create your first simulcast configuration',
    createFirstSimulcast: 'Create First Configuration',
    youtubeLive: 'YouTube Live',
    facebookLive: 'Facebook Live',
    twitchLive: 'Twitch',
    tiktokLive: 'TikTok Live',
    instagramLive: 'Instagram Live',
    
    // Player
    title: 'Player',
    subtitle: 'Preview your channels and get embed codes',
    selectChannelLabel: 'Select Channel',
    selectHere: 'Select Here',
    selectChannel: 'Select a channel',
    noSignal: 'No video signal to display',
    shareChannel: 'Share Channel',
    autoplay: 'Autoplay',
    muted: 'Muted',
    playerUrl: 'PLAYER URL',
    url: 'URL',
    iframeCode: 'IFRAME CODE',
    copyIframe: 'Copy iFrame',
    channelStatus: 'Channel Status',
    live: 'Live',
    offline: 'Offline',
    autoResolution: 'Automatic resolution',
    channelsError: 'Could not load your channels',
    channelError: 'Channel not found or configuration error',
    copied: 'copied',
    copyError: 'Error copying',
    player: 'Player',
    embedCode: 'Embed Code',
    copyEmbedCode: 'Copy Code',
    embedCodeCopied: 'Code copied',
    sharePlayer: 'Share Player',
    noChannelSelected: 'No channel selected',
    playerError: 'Error loading player',
    liveStream: 'Live Stream',
    
    // Analytics
    analytics: 'Analytics',
    overview: 'Overview',
    totalViews: 'Total Views',
    totalWatchTime: 'Total Watch Time',
    averageWatchTime: 'Average Watch Time',
    peakViewers: 'Peak Viewers',
    activityChart: 'Activity',
    contentDistribution: 'Content Distribution',
    trends: 'Trends',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    last90Days: 'Last 90 days',
    exportData: 'Export Data',
    
    // Timezones
    timezones: {
      'UTC': 'UTC',
      'America/Mexico_City': 'Mexico City (GMT-6)',
      'America/New_York': 'New York (GMT-5)',
      'America/Los_Angeles': 'Los Angeles (GMT-8)',
      'America/Chicago': 'Chicago (GMT-6)',
      'America/Denver': 'Denver (GMT-7)',
      'America/Toronto': 'Toronto (GMT-5)',
      'America/Vancouver': 'Vancouver (GMT-8)',
      'America/Sao_Paulo': 'São Paulo (GMT-3)',
      'America/Buenos_Aires': 'Buenos Aires (GMT-3)',
      'America/Lima': 'Lima (GMT-5)',
      'America/Bogota': 'Bogotá (GMT-5)',
      'Europe/Madrid': 'Madrid (GMT+1)',
      'Europe/London': 'London (GMT+0)',
      'Europe/Paris': 'Paris (GMT+1)',
      'Europe/Berlin': 'Berlin (GMT+1)',
      'Europe/Rome': 'Rome (GMT+1)',
      'Europe/Amsterdam': 'Amsterdam (GMT+1)',
      'Europe/Stockholm': 'Stockholm (GMT+1)',
      'Asia/Tokyo': 'Tokyo (GMT+9)',
      'Asia/Shanghai': 'Shanghai (GMT+8)',
      'Asia/Hong_Kong': 'Hong Kong (GMT+8)',
      'Asia/Singapore': 'Singapore (GMT+8)',
      'Asia/Dubai': 'Dubai (GMT+4)',
      'Australia/Sydney': 'Sydney (GMT+10)',
      'Australia/Melbourne': 'Melbourne (GMT+10)',
      'Pacific/Auckland': 'Auckland (GMT+12)',
      'Pacific/Honolulu': 'Honolulu (GMT-10)',
      'Africa/Cairo': 'Cairo (GMT+2)',
      'Africa/Johannesburg': 'Johannesburg (GMT+2)'
    }
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'es';
  });
  const [timezone, setTimezone] = useState(() => {
    return localStorage.getItem('timezone') || 'UTC';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  useEffect(() => {
    localStorage.setItem('timezone', timezone);
  }, [timezone]);

  // Sync language/timezone from DB on startup (in case user logs in from different device)
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch('/api/settings', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data) return;
        if (data.language && data.language !== language) setLanguage(data.language);
        if (data.timezone && data.timezone !== timezone) setTimezone(data.timezone);
      })
      .catch(() => {}); // silently ignore if API is unavailable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once on mount

  const t = (key) => {
    return translations[language][key] || key;
  };

  const getTimezoneLabel = (timezoneKey) => {
    return translations[language].timezones[timezoneKey] || timezoneKey;
  };

  const getAllTimezones = () => {
    return Object.keys(translations[language].timezones).map(key => ({
      value: key,
      label: translations[language].timezones[key]
    }));
  };

  const value = {
    language,
    setLanguage,
    timezone,
    setTimezone,
    t,
    getTimezoneLabel,
    getAllTimezones
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
